import type { AddressFieldsValues } from '@backmarket/http-api/src/api-specs-shipping/address/address-validation.types'

export type FormValues = Required<
  Pick<
    AddressFieldsValues,
    | 'firstName'
    | 'lastName'
    | 'city'
    | 'email'
    | 'company'
    | 'street'
    | 'postalCode'
    | 'country'
    | 'phone'
    | 'stateOrProvince'
    | 'legal'
    | 'password'
    | 'referralCode'
  >
> &
  Pick<
    AddressFieldsValues,
    'firstNamePronunciation' | 'lastNamePronunciation' | 'defaultCountry'
  >

/** Temporarily introduced due to COFO-417 & changes made in https://github.com/BackMarket/front-apps/pull/9098
 * FIXME: Revisit this to check type sanity after initiative is concluded.
 */
export type NonNullableFormValues = {
  [K in keyof FormValues]: Exclude<FormValues[K], null>
}

export type RegisterBody = {
  company: string
  country: string
  trackingCode?: string
  address: {
    country: string
    city: string
    postalCode: string
    company: string
    firstName: string
    lastName: string
    phoneNumber: string
    addressLine: string
    firstNamePronunciation?: string
    lastNamePronunciation?: string
    state?: string
  }
}

export const PASSWORD_MIN_LENGTH = 8
export const METADATA = { scope: 'seller' } as const
